<template>
  <button
    v-if="isShareMobile"
    @click.stop.prevent="shareMobile"
    class="share-button"
    title="Einladung teilen"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24px"
      height="24px"
      viewBox="0 -960 960 960"
      fill="currentColor"
    >
      <path
        d="M691.62-40.09q-61.53 0-104.92-43.09-43.4-43.09-43.4-104.65 0-8.3 3.44-25.78L282.09-364.74q-19.34 15.75-43.19 24.46-23.84 8.72-50.51 8.72-62.12 0-105.21-43.35-43.09-43.34-43.09-105.26t43.09-105.59q43.09-43.68 105.21-43.68 27.13 0 51.5 9.27 24.36 9.26 43.89 25.6l262.39-151q-1.43-6.86-2.15-13.52-.72-6.65-.72-12.95 0-62.03 43.42-105.45 43.41-43.42 105.43-43.42 61.55 0 104.72 43.65 43.17 43.64 43.17 105.19t-43.36 104.72q-43.36 43.18-104.51 43.18-27.64 0-53.08-9.57-25.44-9.56-44.57-26.56L333.96-512.57q2 8.03 2.71 16.41.72 8.38.72 16.44 0 8.07-.5 16.18-.5 8.1-3.06 16.37l260 148.73q20.26-18.13 44.86-27.97 24.61-9.85 53.48-9.85 61.62 0 104.75 43.32 43.12 43.33 43.12 105.22 0 61.65-43.44 104.64T691.62-40.09Zm-.62-117.3q12.92 0 22.33-9.27 9.41-9.27 9.41-22.31t-9.24-21.51q-9.24-8.48-22.89-8.48-12 0-21 8.89-9 8.88-9 21.15 0 12.53 8.74 22.03 8.73 9.5 21.65 9.5ZM188.32-448.87q13.38 0 22.57-9.1 9.2-9.11 9.2-22.57t-9.31-22.53q-9.3-9.06-22.3-9.06-12.99 0-22.04 9.02-9.05 9.01-9.05 22.34 0 13.34 8.89 22.62 8.89 9.28 22.04 9.28Zm524.85-301.49q9-8.87 9-22 0-13.12-8.87-22.18-8.88-9.07-22-9.07-13.13 0-22.19 9.05-9.07 9.06-9.07 22.44 0 12.9 9.24 21.77t22.07 8.87q12.82 0 21.82-8.88Zm-20.43 561.97ZM188.96-480.43Zm503.21-292.61Z"
      />
    </svg>
  </button>
</template>

<script>
export default {
  name: "ShareIconButton",
  props: {
    url: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
  },
  computed: {
    isShareMobile() {
      return navigator.share !== undefined;
    },
  },
  methods: {
    shareMobile() {
      if (navigator.share) {
        navigator
          .share({
            title: "",
            text: this.text,
            url: this.url,
          })
          .then(() => console.log("Successful share"))
          .catch((error) => console.log("Error sharing:", error));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.share-button {
  align-self: start;
  margin-left: 1em;
  display: grid;
  place-items: center;
  aspect-ratio: 1 / 1;
  color: $vca-new-blue;
  background: $white;
  border: 2px solid $vca-new-blue;
  border-radius: 100%;
  cursor: pointer;
  transition: color 0.3s, background-color 0.3s, border-color 0.3s;

  &:hover {
    color: $white;
    background-color: $vca-new-blue;
    border-color: $white;
  }
}
</style>
